
export const getSettings_type = "GET_SETTINGS";
export const getSettingsSuccess_type = "GET_SETTINGS_SUCCESS";
export const getSettingsFailed_type = "GET_SETTINGS_FAILED";

export const getTheme_type = "GET_THEME";